import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "lib/i18n";

const AppliedAiResearch = () => {
  const { t } = useTranslation();
  const tracks = Array.isArray(t("aiResearch.tracks")) ? t("aiResearch.tracks") : [];
  const signals = Array.isArray(t("aiResearch.signals")) ? t("aiResearch.signals") : [];

  return (
    <section className="ai-research-section text-white">
      <div className="container">
        <div className="ai-research-shell">
          <div className="ai-research-intro">
            <p className="ai-section-eyebrow title-font-2">{t("aiResearch.eyebrow")}</p>
            <h2 className="title-font">{t("aiResearch.heading")}</h2>
            <p className="title-font-2">{t("aiResearch.body")}</p>
            <div className="ai-research-actions">
              <Link to="/services" className="btn cta-accent" role="button">
                {t("aiResearch.primaryCta")}
              </Link>
              <Link to="/contact" className="btn home-update-secondary" role="button">
                {t("aiResearch.secondaryCta")}
              </Link>
            </div>
          </div>

          <aside className="ai-research-signals" aria-label={t("aiResearch.signalsHeading")}>
            <div className="ai-research-signals-header">
              <span className="title-font-2">{t("aiResearch.signalsEyebrow")}</span>
              <strong className="title-font-2">{t("aiResearch.signalsHeading")}</strong>
            </div>
            <div className="ai-research-signals-grid">
              {signals.map((signal) => (
                <div className="ai-research-signal" key={signal}>
                  <span className="title-font-2">{signal}</span>
                </div>
              ))}
            </div>
          </aside>
        </div>

        <div className="ai-research-grid">
          {tracks.map((track, index) => (
            <article className="ai-research-card" key={track.title}>
              <span className="ai-research-card-index title-font">0{index + 1}</span>
              <p className="ai-research-card-eyebrow title-font-2">{track.eyebrow}</p>
              <h3 className="title-font-2">{track.title}</h3>
              <p className="title-font-2">{track.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AppliedAiResearch;
